export default {
  links: {},
  forms: [],
  form: [],
  pagination: {},
};
